import { render, staticRenderFns } from "./DCDetails.vue?vue&type=template&id=a6a3b518&scoped=true&"
import script from "./DCDetails.vue?vue&type=script&lang=js&"
export * from "./DCDetails.vue?vue&type=script&lang=js&"
import style0 from "./DCDetails.vue?vue&type=style&index=0&id=a6a3b518&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a3b518",
  null
  
)

export default component.exports